import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SelectionListItem from '@wix/da-ds/pkg/SelectionList/SelectionListItem';
import { BiData } from '@wix/da-bi/pkg/events';
var ManageTier = function (_a) {
    var deviation = _a.deviation, unsubscribe = _a.unsubscribe;
    var t = useTranslation().t;
    var isMultistepCoreCancellation = useFlag('multistep_core_cancellation');
    return (React.createElement(SelectionListItem, { label: t('deviationview.tierCard.moreActionsMenu.item.unsubscribe'), onClick: isMultistepCoreCancellation
            ? function () { return window.location.assign(Url.account(deviation.deviationId)); }
            : unsubscribe, biData: BiData({
            evid: 560,
            subscription_type: 'subscription',
        }) }));
};
ManageTier.displayName = 'ManageTier';
export default ManageTier;
//# sourceMappingURL=ManageTier.js.map